interface ConsentState {
  signedScrollViewConsents: string[];
  scrollViewConsentIndex: number;
  signedListViewConsents: boolean;
}

type ConsentAction =
  | { type: "SIGN_CONSENT"; external_id: string }
  | { type: "UNSIGN_CONSENT"; external_id: string }
  | { type: "TOGGLE_LIST_SIGN"; value: boolean }
  | { type: "INCREMENT_CONSENT"; step: "next" | "previous" }
  | { type: "SET_INITIAL_STATE" }
  | {
      type: "SET_COMPLETED_STATE";
      scrollViewConsentIDs: string[];
    };

export const initialState: ConsentState = {
  signedScrollViewConsents: [],
  scrollViewConsentIndex: 0,
  signedListViewConsents: false,
};

export const manageConsent = (
  state: ConsentState,
  action: ConsentAction
): ConsentState => {
  switch (action.type) {
    case "SIGN_CONSENT":
      return {
        ...state,
        signedScrollViewConsents: [
          ...state.signedScrollViewConsents,
          action.external_id,
        ],
      };
    case "UNSIGN_CONSENT":
      return {
        ...state,
        signedScrollViewConsents: state.signedScrollViewConsents.filter(
          (id) => id !== action.external_id
        ),
      };
    case "TOGGLE_LIST_SIGN":
      return {
        ...state,
        signedListViewConsents: action.value,
      };
    case "INCREMENT_CONSENT":
      return {
        ...state,
        scrollViewConsentIndex:
          action.step === "next"
            ? state.scrollViewConsentIndex + 1
            : state.scrollViewConsentIndex - 1,
      };
    case "SET_COMPLETED_STATE":
      return {
        signedScrollViewConsents: action.scrollViewConsentIDs,
        scrollViewConsentIndex: 0,
        signedListViewConsents: true,
      };
    case "SET_INITIAL_STATE":
      return initialState;
    default:
      return state;
  }
};
